import { Grid, Typography } from '@mui/material'
import React from 'react'

const Education = (props:any) => {
    console.log(props)
    const postGrad = [
        {
          key: "Specialization",
          label: props?.data?.postGraduation?.specialization,
        },
        {
            key: "Degree Program",
            label: props?.data?.postGraduation?.degreeProgram,
          },
        
        {
          key: "Education Status",
          label: props?.data?.postGraduation && props?.data?.postGraduation?.isCompleted ? "Completed":"",
        },
        {
            key: "Name of Institution",
            label: props?.data?.postGraduation?.instituteName,
          },
          {
            key: "Affiliating University / Board of Education",
            label: props?.data?.postGraduation?.affiliatedUniversity,
          },
        {
          key: "Grade Scheme",
          label: props?.data?.postGraduation?.gradingSystem,
        },
        {
          key: "Score",
          label: props?.data?.postGraduation?.totalScore,
        },
        {
          key: "Attended From",
          label: props?.data?.postGraduation?.startDate?props?.data?.postGraduation?.startDate.slice(0,10):"",
        },
        {
          key: "Completed On",
          label: props?.data?.postGraduation?.endDate?props?.data?.postGraduation?.endDate.slice(0,10):"",
        },
        {
          key: "Backlogs",
        label: props?.data?.postGraduation?.backlogs,
        },
        
        {
            key:"Country",
            label:props?.data?.postGraduation?.country
        },
        {
            key:"City",
            label:props?.data?.postGraduation?.state
        },{
            key:"State",
            label:props?.data?.postGraduation?.city
        }
      ];
      const underGrad = [
        {
          key: "Specialization",
          label: props?.data?.underGraduation?.programMajor,
        },
        {
            key: "Degree Program",
            label: props?.data?.underGraduation?.degreeProgram,
          },
        
        {
          key: "Education Status",
          label: props?.data?.underGraduation?.isCompleted ? "Completed":"",
        },
        {
            key: "Name of Institution",
            label: props?.data?.underGraduation?.instituteName,
          },
          {
            key: "Affiliating University / Board of Education",
            label: props?.data?.underGraduation?.affiliatedUniversity,
          },
        {
          key: "Grade Scheme",
          label: props?.data?.underGraduation?.gradingSystem,
        },
        {
          key: "Score",
          label: props?.data?.underGraduation?.totalScore,
        },
        {
          key: "Attended From",
          label: props?.data?.underGraduation?.startDate?props?.data?.underGraduation?.startDate.slice(0,10):"",
        },
        {
          key: "Completed On",
          label: props?.data?.underGraduation?.endDate?props?.data?.underGraduation?.endDate.slice(0,10):"",
        },
        {
          key: "Backlogs",
        label: props?.data?.underGraduation?.backlogs,
        },
        
        {
            key:"Country",
            label:props?.data?.underGraduation?.country
        },
        {
            key:"City",
            label:props?.data?.underGraduation?.state
        },{
            key:"State",
            label:props?.data?.underGraduation?.city
        }
      ]; 
      const plus2 = [
        {
          key: "Specialization",
          label: props?.data?.plus2?.stream,
        },
        {
            key: "Board",
            label: props?.data?.plus2?.board,
          },
        
        {
          key: "Education Status",
          label: props?.data?.plus2?.isCompleted? "Completed":"",
        },
        {
            key: "Name of Institution",
            label: props?.data?.plus2?.instituteName,
          },
        {
          key: "Grade Scheme",
          label: props?.data?.plus2?.gradingSystem,
        },
        {
          key: "Score",
          label: props?.data?.plus2?.totalScore,
        },
        {
          key: "Attended From",
          label: props?.data?.plus2?.startDate?props?.data?.plus2?.startDate.slice(0,10):"",
        },
        {
          key: "Completed On",
          label: props?.data?.plus2?.endDate?props?.data?.plus2?.endDate.slice(0,10):"",
        },
        {
          key: "Backlogs",
        label: props?.data?.plus2?.backlogs,
        },
        
        {
            key:"Country",
            label:props?.data?.plus2?.country
        },
        {
            key:"City",
            label:props?.data?.plus2?.state
        },{
            key:"State",
            label:props?.data?.plus2?.city
        }
      ];  
      const school = [
        {
            key: "Board",
            label: props?.data?.school?.board,
          },
        
        {
          key: "Education Status",
          label: props?.data?.school?.isCompleted? "Completed":"",
        },
        {
            key: "Name of Institution",
            label: props?.data?.school?.instituteName,
          },
        {
          key: "Grade Scheme",
          label: props?.data?.school?.gradingSystem,
        },
        {
          key: "Score",
          label: props?.data?.school?.totalScore,
        },
        {
          key: "Attended From",
          label: props?.data?.school?.startDate?props?.data?.school?.startDate.slice(0,10):"",
        },
        {
          key: "Completed On",
          label: props?.data?.school?.endDate?props?.data?.school?.endDate.slice(0,10):"",
        },
        {
          key: "Backlogs",
        label: props?.data?.school?.backlogs,
        },
        
        {
            key:"Country",
            label:props?.data?.school?.country
        },
        {
            key:"State",
            label:props?.data?.school?.state
        },{
            key:"City",
            label:props?.data?.school?.city
        }
      ]; 
  return (
    <div>
    <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",mb:2}}>Masters</Typography>
    <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
      {postGrad?.map((item,i) => (
        <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                sx={{
                  minWidth: 150,
                  color: "#7C7A7A",
                  fontSize: "14px",
                }}
              >
                {item.key}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{item.label}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
    <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",my:2}}>Bachelors</Typography>
    <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
      {underGrad?.map((item,i) => (
        <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                sx={{
                  minWidth: 150,
                  color: "#7C7A7A",
                  fontSize: "14px",
                }}
              >
                {item.key}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{item.label}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
    <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",my:2}}>Grade 12</Typography>
    <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
      {plus2?.map((item,i) => (
        <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                sx={{
                  minWidth: 150,
                  color: "#7C7A7A",
                  fontSize: "14px",
                }}
              >
                {item.key}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{item.label}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
    <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",my:2}}>Grade 10</Typography>
    <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}>
      {school?.map((item,i) => (
        <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                sx={{
                  minWidth: 150,
                  color: "#7C7A7A",
                  fontSize: "14px",
                }}
              >
                {item.key}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{item.label}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
    </div>
  )
}

export default Education